/**
 * @author Mamatha siripi
 * @dashBoard Bulk Consent Template Registration
 */


import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common'; 
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIEntityService } from '../../_services/entity/API-entity';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs as importedSaveAs } from "file-saver";
import * as XLSX from 'xlsx';


export class CSVRecord {
  public CSTempName: any;
  public ContentTemplateIDs: any;
  public BrandName: any;
  public CSTempContent: any;
}

@Component({
  selector: 'app-bulk-consent-template-registration',
  templateUrl: './bulk-consent-template-registration.component.html',
  styleUrls: ['./bulk-consent-template-registration.component.css']
})
export class BulkConsentTemplateRegistrationComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private es: APIEntityService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private router: Router
  ) { }
  // uploadNcpr: FileList;
  importForm: FormGroup;
  validfilecontent: boolean = true;
  uploadFile: string[];
  public Entity_Ref_No: any;
  public Entity_Name: any;
  orgType: any;
  addDocFlag: boolean = false;
  errDoc: boolean = false;
  public records: any[] = [];
  uploader: string[];
  errorMassage: string;
  errorMsg: boolean;
  files: any[] = [];
  storeData: any;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  fileExtensionError: boolean = false;
  fileExtensionMessage: any;
  fileExtension: any;
  myfiles: any[] = [];
  fileUploaded: File;
  uploadKYC: string[];
  photoName: any;
  worksheet: any;

  ngOnInit() {
    // if(this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN) ==null && this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID)== null){
    //   this.router.navigate(['/']);
    //}
    console.log(this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN))
    this.importForm = this.fb.group({
      uploadKYC: ['', Validators.required],
      DocName: ['',]

    });
  }
  get f() { return this.importForm.controls; }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
  bulkUploadSchema(schema){
    var fileName =   'ConsentTemplate.csv';
    const fields = ['CSTempName', 'BrandName', 'CSTempContent'];
       this.es.consentTemplate(schema)
        .subscribe((r) => {
          importedSaveAs(r, fileName)
        })
      
    } 
    onChangeFileUpload(event) {
      this.myfiles=[];

      this.errorMsg = false;
      this.fileUploaded = event.target.files[0];
      this.photoName = this.fileUploaded.name;
      let fileNameArr = this.photoName.split('.')
      if(fileNameArr.length>2){
        // this.fileDoubleExtensionError = true
        this.$modal.errorModal({
          title: 'Bulk Content Template Registration',
          msg: 'File with double extension is not allowed!' 
        })
        this.resetKYC(0)
      }else{
        var allowedExtensions =
        ["csv", "xlsx"];
      this.fileExtension = this.fileUploaded.name.split('.').pop();
  
      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError = false;
        this.fileExtensionMessage = ""
      } else {
        this.fileExtensionMessage = "Only photos allowed!!"
        this.fileExtensionError = true;
        return true;
      }
  
      this.myfiles.push(event.target.files[0])
      console.log(this.myfiles);
      // this.uploadKYC = this.myfiles;
  
      if (this.fileUploaded.size > 4242880) {
        console.log("The size is more ")
        this.fileSizeError1 = true;
      }
      else {
        this.fileSizeError1 = false;
      }
      if (this.fileUploaded.size <= 0) {
        console.log("The size is less ")
        this.fileSizeError2 = true;
      }
      else {
        this.fileSizeError2 = false;
      }
      if (this.isValidCSVFile(event.target.files[0])) {
      this.readCSVFile(event.target.files[0]);
      }else if(this.isValidxlsxFile(event.target.files[0])){
        this.readExcel();
      }
      }
    }
  
 
  
    getHeaderArray(csvRecordsArr: any) {
      let headers = (<string>csvRecordsArr[0]).split(',');
      let headerArray = [];
      for (let j = 0; j < headers.length; j++) {
        headerArray.push(headers[j]);
      }
      if ((headerArray[0] == "CSTempName")  && (headerArray[1] == "BrandName") && (headerArray[2] == "CSTempContent") && headerArray.length == 3) //&& (headerArray[1] == "ContentTemplateIDs")
      {
        this.validfilecontent = true
        console.log("Valid CSV Contents");
              this.uploadKYC = this.myfiles;

      }
      else {
        this.validfilecontent = false
        console.log("Status update", this.validfilecontent)
        this.errorMsg = true;
        this.errorMassage = "Upload a valid CSV File";
      }
      return headerArray;
    }
    getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
      let csvArr = [];
      for (let i = 1; i < csvRecordsArray.length; i++) {
        let curruntRecord = (<string>csvRecordsArray[i]).split(',');
        if (curruntRecord.length == headerLength) {
          let csvRecord: CSVRecord = new CSVRecord();
          csvRecord.CSTempName = curruntRecord[0].trim();
          // csvRecord.ContentTemplateIDs = curruntRecord[1].trim();
           csvRecord.BrandName = curruntRecord[2].trim();
           csvRecord.CSTempContent = curruntRecord[3].trim();
       
          csvArr.push(csvRecord);
        }
      }
      return csvArr;
    }
   
    isValidCSVFile(file: any) {
      return file.name.endsWith(".csv");
    }
    isValidxlsxFile(file: any) {
      return file.name.endsWith(".xlsx");
    }
  
    readCSVFile($event: any) {
      let text = [];
      // this.files = $event.srcElement.files;
      // if (this.isValidCSVFile(this.files[0])) {
        let input = $event.target;
        let reader = new FileReader();
        reader.readAsText(this.fileUploaded);
        reader.onload = () => {
          let csvData = reader.result;
          let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
          let headersRow = this.getHeaderArray(csvRecordsArray);
          this.records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);

        };
        reader.onerror = function () {
          console.log('error is occured while reading file!');
        };
     // } 
      // else {
      //   alert("Please import valid .csv file.");
  
      // }
    }
    readExcel() {
      let readFile = new FileReader();
      readFile.onload = (e) => {
        this.storeData = readFile.result;
        var data = new Uint8Array(this.storeData);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var first_sheet_name = workbook.SheetNames[0];
        this.worksheet = workbook.Sheets[first_sheet_name];
        this.uploadKYC = this.myfiles;

  
      }
      console.log(this.fileUploaded);
      readFile.readAsArrayBuffer(this.fileUploaded);
    }

  resetKYC(index) {
    this.myfiles.splice(index, 1)
    this.importForm.controls['uploadKYC'].reset();
    this.errorMsg = false;

  }

  addDocument() {
    if (this.addDocFlag == true) {
      this.errDoc = true;
    }
    else {
      this.addDocFlag = true;
    }
  }


  onSubmit() {
     let file = new Blob(this.files, { type: "application/csv" });
   
    const importForm: FormData = new FormData();
    let now = new Date();
    const uploadDate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
    const file1: any = document.getElementById('uploadKYC');

    if (this.importForm.invalid) {
      this.errorMassage = "Please Select CSV File"
      this.errorMsg = true;
      return;
    } 

    else  {
      if (this.errorMsg) {
        return;
       }
       this.errorMsg = false;
      let peId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      let E_Org_Name = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);

      importForm.append('CST_CreatedDate', uploadDate);

      //importForm.append('Entity_ID', '1601100000000000002');
	  importForm.append('Entity_ID', peId);
      // importForm.append("filename", file, file1.files[0].name);
      importForm.append('file1', file1.files[0]);

      importForm.append('Entity_Class', "PE");
      importForm.append('Industry_Cat', this.orgType);
      importForm.append('Entity_OrganizationName', E_Org_Name);
      this.es.importBulkCSTRegistration(importForm)
      .subscribe(r => {
        if (r.status == "success") {
          this.$modal.successModal({
            title: 'Import Consent Template',
            msg: r.message
          });

          this.router.navigateByUrl('/consent-template-bulk-upload-summary');
        }
      else if (r.status == "fail") {
        this.$modal.errorModal({
          title: 'Import Consent Template',
          msg:  r.message
        });
      }
    
    })
  }
   
  }
}
